module.exports = __webpack_public_path__ + "static/media/cancelled.b933aa1a.gif";